import { loadable } from 'utils';

export const Documents = loadable(() => import('./Documents'), {});
